module.exports = __webpack_public_path__ + "static/media/bellIcon.e394f189.svg";